import { render, staticRenderFns } from "./FacilityEditPhones.vue?vue&type=template&id=4ed5a6f3&"
import script from "./FacilityEditPhones.vue?vue&type=script&lang=js&"
export * from "./FacilityEditPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports